import { API, setAuthToken } from '../../../config/API.js';
import { GET_HOTEL, SET_LOADING_HOTEL, SET_PAGINATION_HOTEL } from '../constant.js';

export const getHotel = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_HOTEL,
      payload: true,
    });
    API.get(`admin/property/hotel?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_HOTEL,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_HOTEL,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_HOTEL,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_HOTEL,
          payload: 0,
        });
      });
  };
};

export const addHotel = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/hotel/add", params);
};

export const getDetailHotel = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/property/hotel/${code}`);
};

export const updHotel = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/hotel/edit", params);
};

export const delHotel = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/property/hotel/delete/" + code);
};
